<template>
  <div class="collection">
    <!-- tab切换按钮 -->
    <div class="tab_btns">
      <button :class="{clicked:tab_index===0}" @click="tab_index=0">作品</button>
      <button :class="{clicked:tab_index===1}" @click="tab_index=1">任务</button>
      <button :class="{clicked:tab_index===2}" @click="tab_index=2">学院</button>
    </div>
    <!-- 收藏的作品 -->
    <collection_opus v-if="tab_index === 0"></collection_opus>
    <!-- 收藏的任务 -->
    <collection_task v-if="tab_index === 1"></collection_task>
    <!-- 收藏的设计学院 -->
    <collection_school v-if="tab_index === 2"></collection_school>
  </div>
</template>

<script>
import collection_opus from "./collection_opus/index.vue";
import collection_task from "./collection_task/index.vue";
import collection_school from "./collection_school/index.vue";
export default {
  components: {
    collection_opus,
    collection_task,
    collection_school
  },
  data() {
    return {
      tab_index: 0 //tab切换index
    };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.collection {
  width: 862px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  padding-top: 30px;
  .tab_btns {
    position: absolute;
    left: 0;
    top: -20px;
    button {
      width: 90px;
      height: 38px;
      border: 0;
      outline: 0;
      border-radius: 19px;
      cursor: pointer;
      margin-right: 15px;
      // font-size: 12px;
      background-color: #f5f5f5;
      color: #999;
    }
    button:hover {
      background-color: rgba($color: #e7e7e7, $alpha: 0.9);
      color: #333;
    }
    .clicked {
      background-color: rgba($color: #e7e7e7, $alpha: 0.9);
      color: #333;
    }
  }
  .opus_item {
    margin-right: 20px;
  }
  .opus_item:nth-child(3n) {
    margin-right: 0;
  }
}
</style>